import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import Logo from '../components/ui/Logo';
import api from '../services/api';
import toast from 'react-hot-toast';
import { SELLERCLUB_SUPPORT_PHONE_DISPLAY } from '../constants/support';

export default function SellerSignup() {
  const { isDarkMode } = useTheme();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleContinue = async (e) => {
    e.preventDefault();
    if (!email?.includes('@')) {
      toast.error('Enter a valid email address');
      return;
    }
    setLoading(true);
    try {
      const clientUrl = encodeURIComponent(window.location.origin);
      const response = await api.get(
        `/onboarding/amazon/start?email=${encodeURIComponent(email)}&type=onboarding&clientUrl=${clientUrl}`
      );
      if (response.data.success) {
        window.location.href = response.data.authUrl;
        return;
      }
      toast.error(response.data.error || 'Could not start signup');
    } catch (error) {
      toast.error(error.response?.data?.error || error.message || 'Could not start signup');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`min-h-screen flex items-center justify-center px-4 py-12 ${
        isDarkMode ? 'bg-stone-950' : 'bg-gradient-to-br from-orange-50 via-white to-amber-50'
      }`}
    >
      <div className="w-full max-w-[21rem]">
        <div
          className={`rounded-2xl border shadow-xl overflow-hidden ${
            isDarkMode ? 'bg-slate-900 border-slate-700' : 'bg-white border-slate-200'
          }`}
        >
          <div className="bg-gradient-to-r from-orange-500 to-amber-500 px-5 py-6 text-center text-white">
            <Logo className="justify-center mb-2" size="md" />
            <h1 className="text-xl font-bold">Seller sign up</h1>
            <p className="text-sm text-orange-100 mt-1">Connect your Amazon Advertising stores to SellerClub</p>
          </div>

          <form onSubmit={handleContinue} className="p-5 space-y-4">
            <ol className="text-sm space-y-2 text-slate-600 dark:text-slate-400 list-decimal list-inside">
              <li>Enter the email you want on your SellerClub account</li>
              <li>Sign in with Amazon and choose which stores to connect</li>
              <li>After admin approval, return to <strong className="text-slate-800 dark:text-slate-200">Login</strong> with the same email</li>
            </ol>

            <div>
              <label
                htmlFor="signup-email"
                className="block text-sm font-medium mb-2 text-slate-700 dark:text-slate-300"
              >
                Your email
              </label>
              <input
                id="signup-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@business.com"
                className={`w-full px-4 py-3 rounded-xl border text-sm ${
                  isDarkMode
                    ? 'bg-slate-800 border-slate-600 text-white placeholder-slate-500 focus:border-orange-500'
                    : 'bg-white border-slate-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-500/20'
                }`}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 rounded-xl font-semibold text-white bg-orange-600 hover:bg-orange-700 disabled:opacity-50 shadow-sm"
            >
              {loading ? 'Redirecting to Amazon…' : 'Continue with Amazon'}
            </button>

            <p className="text-xs text-center text-slate-500 dark:text-slate-400">
              Already have an account?{' '}
              <Link to="/login" className="font-semibold text-orange-600 hover:text-orange-700 dark:text-orange-400">
                Log in
              </Link>
            </p>
            <p className="text-xs text-center text-slate-500">
              Help: {SELLERCLUB_SUPPORT_PHONE_DISPLAY}
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
